<template>
    <v-card elevation="0">
        <div>
            <div class="tit-wrap mb-10px mb-md-20px">
                <h3 class="tit tit--xs">회원정보(필수)</h3>
            </div>

            <div class="table-style table-style--default">
                <div class="table-style__row">
                    <div class="table-style__th">아이디</div>
                    <div class="table-style__td">
                        <v-row class="row--x-small">
                            <v-col cols="12">
                                <div class="my-6px">
                                    <v-text-field v-model="member.username" v-bind="$attrs" placeholder="아이디" outlined hide-details clearable @input="exists()"/>
                                    <div v-if="errors" style="color: red; font-size: 14px">*{{errors}}</div>
                                    <p class="font-size-14 primary--text pt-6px">* 4~12 영문·숫자 조합, 가입 후 아이디 변경은 불가능함을 알려드립니다.</p>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <div class="table-style__row">
                    <div class="table-style__th">비밀번호</div>
                    <div class="table-style__td">
                        <v-row class="row--x-small">
                            <v-col cols="12">
                                <v-password-field v-model="member.password" v-bind="$attrs" placeholder="비밀번호" outlined hide-details autocomplete="new-password"/>
                            </v-col>
                            <v-col cols="12">
                                <v-password-field v-model="member.password2" v-bind="$attrs" placeholder="비밀번호확인" outlined hide-details />
                                <div style="color: red; font-size: 14px">{{passwordErrors}}</div>
                                <p class="font-size-14 primary--text pt-6px">* 영문·숫자·특수문자 조합으로 10자리 이상 20자리 이하입니다.</p>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <div class="table-style__row">
                    <div class="table-style__th">이름</div>
                    <div class="table-style__td">
                        <v-row class="row--x-small">
                            <v-col md="6">
                                <v-text-field v-model="member.name" v-bind="$attrs" placeholder="이름" outlined hide-details readonly @click="$refs.kcpCert.open()"/>
                            </v-col>
                            <v-col cols="auto" md="6">
                                <v-btn large color="primary" class="v-btn--input" @click="$refs.kcpCert.open()">본인인증</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <div class="table-style__row">
                    <div class="table-style__th">연락처</div>
                    <div class="table-style__td">
                        <v-row class="row--x-small">
                            <v-col cols="12">
                                <v-row align="center" class="row--small">
                                    <v-col>
                                        <v-text-field v-model="member.phone1" v-bind="$attrs" placeholder="연락처" outlined hide-details readonly @click="$refs.kcpCert.open()"/>
                                    </v-col>
                                    <v-col cols="auto">-</v-col>
                                    <v-col>
                                        <v-text-field v-model="member.phone2" v-bind="$attrs" maxlength="4" outlined hide-details readonly @click="$refs.kcpCert.open()"/>
                                    </v-col>
                                    <v-col cols="auto">-</v-col>
                                    <v-col>
                                        <v-text-field v-model="member.phone3" v-bind="$attrs" maxlength="4" outlined hide-details readonly @click="$refs.kcpCert.open()"/>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox v-model="member.smsEnabled" label="sms 수신동의" hide-details/>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <div class="table-style__row">
                    <div class="table-style__th">이메일</div>
                    <div class="table-style__td">
                        <v-row class="row--x-small">
                            <v-col cols="12">
                                <v-row align="center" class="row--small">
                                    <v-col>
                                        <v-text-field v-model="member.email1" v-bind="$attrs" placeholder="이메일" outlined hide-details />
                                    </v-col>
                                    <v-col cols="auto">@</v-col>
                                    <v-col>
                                        <v-text-field v-model="member.email2" v-bind="$attrs" hide-details/>
                                    </v-col>
                                    <v-col cols="auto">-</v-col>
                                    <v-col>
                                        <v-select v-model="member.email3" v-bind="$attrs" persistent-hint :items="prependEmails" item-text="text" item-value="value" outlined hide-details @input="member.email2 = member.email3"/>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox v-model="member.emailEnabled" label="email 수신동의" hide-details/>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <div class="table-style__row">
                    <div class="table-style__th">주소</div>
                    <div class="table-style__td">
                        <v-row class="row--x-small">
                            <v-col md="6">
                                <v-text-field v-model="member.postcode" v-bind="$attrs" placeholder="우편번호" outlined hide-details readonly @click="$refs.daumPostcode.open()"/>
                            </v-col>
                            <v-col cols="auto" md="6">
                                <v-btn large color="primary" class="v-btn--input" @click="$refs.daumPostcode.open()">주소검색</v-btn>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="member.address1" v-bind="$attrs" placeholder="기본주소" outlined hide-details readonly @click="$refs.daumPostcode.open()"/>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="member.address2" v-bind="$attrs" placeholder="상세주소" outlined hide-details/>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>

            <div class="mt-20px mt-md-40px text-center">
                <v-btn width="120" x-large color="primary" @click="join">회원가입</v-btn>
            </div>
        </div>

        <kcp-cert ref="kcpCert" @input="certify"></kcp-cert>
        <daum-postcode ref="daumPostcode" @input="({ postcode, address }) => { member.postcode = postcode; member.address1 = address; }"/>
    </v-card>
</template>
<script>
import api from "@/api";
import { mdiCertificateOutline, mdiMagnify } from "@mdi/js"
import CryptoAES from "@/plugins/crypto-aes";
import KcpCert from "@/components/plugins/kcp/kcp-cert.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";

export default {
    components: {
        KcpCert,
        DaumPostcode,
        VPasswordField
    },
    props: ["value"],
    data(){
        return {
            mdiMagnify,
            mdiCertificateOutline,

            member: this.value,

            appendPhones: ["010", "011", "016", "017", "019"],
            prependEmails: [
                { text: ":: 직접입력 ::", value: null },
                { text: "naver.com", value: "naver.com" },
                { text: "gmail.com", value: "gmail.com" },
                { text: "daum.net", value: "daum.net" },
                { text: "hanmail.net", value: "hanmail.net" },
            ],
            passwordErrors: '',
            errors: ''
        }
    },
    methods: {
        validate(){
            try{
                let member = this.member;
                if(!member.username) throw new Error("아이디를 입력해주세요");
                if(this.errors.length) throw new Error(this.errors);
                // if(member.username.match(/[^0-9a-zA-Z]/g) || member.username.length < 3 || 12 < member.username.length) throw new Error("아이디는 영문숫자 3~12자리로 입력해주시기 바랍니다");
                if(!/^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{4,12}$/.test(member.username)) throw new Error("아이디는 영문숫자 4~12자리로 입력해주시기 바랍니다");
                if(!member.password || !member.password2) throw new Error("비밀번호를 입력해주세요");
                if(member.password.match(/ /g) || member.password2.match(/ /g)) throw new Error("비밀번호에 공백은 제외해서 입력해주세요");
                if(member.password != member.password2) throw new Error("비밀번호가 일치하지 않습니다");
                if(0 <= member.password.indexOf(member.username) || !member.password.match(/[0-9]/) || !member.password.match(/[a-zA-Z]/) || !member.password.match(/[`~!@#$%^&*()\-_=+\[\]{};:'",.<>\/\?]/) || member.password.length < 10 || 20 < member.password.length ) throw new Error("비밀번호는 회원 아이디와 동일하지 않아야 하며 영어+숫자+특수문자 혼합 문자로 최소 10~20자리입니다");
                if(!member.name) throw new Error("본인인증을 해주세요");
                if(!member.phone1 || !member.phone2 || !member.phone3) throw new Error("본인인증을 해주세요");
                if(!member.email1 || !member.email2) throw new Error("이메일을 입력해주세요");
                if(member.email1.match(/[@'"`(){}\[\]]/) || member.email1.substr(-1) == '.') throw new Error("이메일 양식을 확인해주세요");
                if(!member.email2.match(/[.]/) || member.email2.match(/[^0-9a-zA-Z.]/)) throw new Error("이메일 양식을 확인해주세요");
                if(!member.postcode) throw new Error("우편번호를 입력해주세요");
                if(!member.address1) throw new Error("기본주소를 입력해주세요");
                // if(member.username.match(/admin/i) || member.username.match(/daehanbooks/i) || member.username.match(/daehanbook/i) || member.username.match(/info/i) || member.username.match(/help/i) || member.username.match(/salerbook/i) || member.username.match(/adm/i) || member.username.match(/staff/i)) throw new Error("admin, daehanbook, daehanbooks, info, help, salerbook, adm, staff는 사용할 수 없는 아이디입니다");

                return true;
            }
            catch(error){
                alert(error.message);
                return false;
            }
        },
        certify(payload){
            let { _cert, name, phone, birthday } = payload;

            this.member._cert = _cert;

            this.member.name = name;

            let [phone1, phone2, phone3] = phone?.phoneNumberFormat?.()?.split?.("-") || [];
            this.member.phone1 = phone1;
            this.member.phone2 = phone2;
            this.member.phone3 = phone3;

            this.member.birthday = birthday;
        },
        async join(){
            if(this.validate()){
                let member = this.member;
                await api.v1.members.post({
                    ...member,
                    password: CryptoAES.encrypt(member.password),
                    password2: null,
                    phone: [member.phone1, member.phone2, member.phone3].join('-'),
                    email: [member.email1, member.email2].join('@')
                });

                this.$emit("next");
            }
        },

        async exists(){
            let { isExists } = await api.v1.members.exists({ params: { username: this.member.username } });
            console.log(isExists)
            this.errors = isExists ? "이미 사용중이거나 사용불가능한 아이디입니다" : "";
        }
    },
    watch: {
        value(){
            this.member = this.value;
        },
        "member.password2"(){
            if(this.member.password === this.member.password2){
                this.passwordErrors = ''
            } else {
                this.passwordErrors = '*비밀번호를 확인해주세요'
            }
        }
    },
    computed: {
        // passwordMath(){
        //     if(this.member.password === this.member.password2){
        //         return true
        //     } else {
        //         return false
        //     }
        // }
    }
}
</script>